import styled from 'styled-components';
import { Box } from '@components/Box';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { Columns } from '@components/Columns';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery } from '@utils/styledTheme.util';
export const StyledBox = styled(Box)`
  height: 1050px;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MultipleInvitesWrapper = styled(Box)<{ backgroundImage: string }>`
  background-image: url(${props => cloudAssetUrl(props.backgroundImage)});
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
`;

export const MultipleRsvpColumnWrapper = styled(Columns.Column)`
  display: flex;
  width: 100%;
  max-width: 100%;
  ${themeMediaQuery('below_sm')} {
    flex-direction: column-reverse;
  }
`;

export const MultipleRsvpTextPairingWrapper = styled(TextPairing)`
  .text-pairing-title {
    max-width: 388px;
  }
  .text-pairing-body {
    max-width: 358px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      max-width: 240px;
    }
    .text-pairing-body {
      max-width: 310px;
    }
  }
`;

export const SendRSVPTextWrapper = styled(TextPairing)`
  .text-pairing-title {
    max-width: 541px;
  }
  .text-pairing-body {
    max-width: 380px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      max-width: 280px;
    }
    .text-pairing-body {
      max-width: 310px;
    }
  }
`;
